export default "__VITE_ASSET__DNkm63oP__"